import { JetpacPayApi } from "api"

class ExternalApi {
  static async getExternalOrdersByID(orderRef: string, faberToken: string) {
    return JetpacPayApi.httpGet(
      `/Jetpac/ops/ext/purchase/ref/${orderRef}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static async getUserExternalOrders(userID: string, faberToken: string) {
    return JetpacPayApi.httpGet(
      `/Jetpac/ops/ext/purchase/user/${userID}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static async cancelExternalPurchase(body: cancelExternalPurchaseProps) {
    return JetpacPayApi.httpPost(
      `/Jetpac/ops/ext/purchase/ref/${body.orderID}/cancel`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }
}

export interface cancelExternalPurchaseProps {
  orderID: string
  faberToken: string
  cancellationReason: string
}

export default ExternalApi
